<template>
	<div class="form-container">
		<h2 class="form-title">고객님의 아이디입니다.</h2>

		<div class="form-group">
			<label class="form-label">아이디</label>
			<div class="form-text">{{ findUserInfo.user_id }}</div>
		</div>

		<div class="form-group">
			<label class="form-label">가입일</label>
			<div class="form-text">{{ findUserInfo.registered_date }}</div>
		</div>

		<div v-if="findUserInfo.hasMultiple" class="form-group">
			<div class="info-message">
				동일한 정보로 가입된 다른 계정이 있을 수 있습니다.<br />
				찾으시는 아이디가 아닌 경우 고객센터로 문의해 주세요.
			</div>
		</div>

		<div class="form-group form-button">
			<div class="columns">
				<div class="column">
					<BaseBtn
						@click="$router.push({ name: 'findPassword' })"
						color="secondary"
						x-large
						block
						>비밀번호 찾기
					</BaseBtn>
				</div>
				<div class="column">
					<BaseBtn
						@click="$router.push({ name: 'login' })"
						color="primary"
						x-large
						block
						>로그인
					</BaseBtn>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import BaseBtn from '@/components/common/Btn';

export default {
	components: {
		BaseBtn,
	},
	computed: {
		findUserInfo() {
			return this.$store.getters['findIdStore/findUserInfo'];
		},
	},
};
</script>
